import * as React from 'react';
/**
 *
 * Original name: file history
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=51991%3A64
 *
 */
export const FileHistoryFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M13 4v5h5v3.072A6.824 6.824 0 0 0 17 12c-1.493 0-2.897.46-3.936 1.467C12.017 14.48 11.5 15.899 11.5 17.5c0 .905.165 1.752.498 2.5H5.5V4H13Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M17.988 7.5H14.5V4.012a2.229 2.229 0 0 1 1.47.647l1.37 1.371c.392.393.622.917.648 1.47Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 17.5c0-2.55 1.621-4 4-4s4 1.45 4 4-1.621 4-4 4-4-1.45-4-4Zm2 .5h2.5v-3h-1v2H15v1Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
